// Reapply the small presentation enhancement after Shopify replaces variant markup.
function enhanceSizing(root = document) {
  root.querySelectorAll('.mc-page-product .variant-option legend').forEach(legend => {
    if (!/^size\s*$/i.test(legend.textContent.trim()) || legend.querySelector('.mc-size-link')) return;
    const details = document.querySelector('.mc-product-disclosures details');
    if (!details || !details.querySelector('table')) return;
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'mc-size-link'; button.textContent = 'Size guide';
    button.addEventListener('click', () => {
      const current = document.querySelector('.mc-product-disclosures details');
      if (!current) return;
      current.open = true;
      current.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'center'});
      current.querySelector('summary').focus();
    });
    legend.append(button);
  });
}
enhanceSizing();
const mcMain = document.getElementById('MainContent');
if (mcMain) {
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; enhanceSizing(); });
  }).observe(mcMain, { childList:true, subtree:true });
}
